export { DSSideNav, DSSideNavWithSchema } from './SideNav.js';
